import React, { useState,useEffect } from 'react'
// import 'bootstrap/dist/css/bootstrap.min.css'
import axios from 'axios'
import { Link } from 'react-router-dom'

const DealsList = () => {

    const API_URL = process.env.REACT_APP_API_URL
    const PRODUCTS_URL = `${API_URL}/products`

    const [data,setData] = useState([]);
    const [loading,setLoading] = useState(false);

    const getApiData = async () => {
        setLoading(true)
        try {
            const res = await axios.get(PRODUCTS_URL);
            setData(res.data.data)
            setLoading(false)
            console.log(res.data.data)
        } catch (error) {
          console.error(error)
          setLoading(false)
        }
      }

      useEffect(()=>{
        getApiData();
      },[])

  return (
    <div className='container py-4'>
      {data.map((category, index) => (
                <div key={index} className='mb-5'>
                 {(category.items.length > 0) && ( 
                    <h2 className='fw-bold mb-5 mt-3 text-primary'>{category.category}</h2>
                 )}   
                <div className='row gx-3 gy-5'>
                    {category.items?.map((product) => (
                    <div key={product.id} className='col-lg-2 col-md-12'>
                                <div className="item">
                                {product.image && (
                                    <div className='d-flex align-items-center justify-content-center' style={{width:'150px',height:'150px',backgroundColor:'white',padding:10,borderRadius:20}}>
                                       <Link to='/products/deals' state={{item_id : product?.id}}> 
                                        <img
                                        src={`https://erp.makemoneyormiles.com/storage/deals/${product.image}`}
                                        alt={product.name}
                                        className='card-img-top'
                                        style={{height: 'auto',width:'125px'}}
                                        />
                                    </Link>
                                    </div>
                                )}
                                <Link to='/products/deals' state={{item_id : product?.id}}>
                                <h5 className='card-title mt-5 text-dark'>{product.name}</h5>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
                {(category.items.length > 0) && (
                <div className="border-bottom my-5"></div>
                )} 
                </div>

      )  
      )}
    </div>
    // <></>
  )
}

export default DealsList
